<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:class="modalSize"
		:preloader="preloader"
		:isNeedButtonFooter="false"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="`transaction/schedule-recommendation`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_course_name" class="col-sm-3 mb-0">
						Class Name
					</label>
					<app-input
						id="inputs_course_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.course_name"
						placeholder="Choose Class"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_course_schedule_name"
						class="col-sm-3 mb-0"
					>
						Class Schedule
					</label>
					<app-input
						id="inputs_course_schedule_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.course_schedule_name"
						placeholder="Choose Class"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_product_id" class="col-sm-3 mb-0">
						Product Name
					</label>
					<app-input
						id="inputs_product_id"
						class="col-sm-9"
						type="text"
						v-model="inputs.product_id"
						placeholder="Choose Class"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_mon" class="col-sm-3 mb-0"> Mon </label>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_1"
						placeholder="Start Time"
						:readonly="true"
						:disabled="true"
					/>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_1"
						placeholder="End Time"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_tue" class="col-sm-3 mb-0"> Tue </label>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_2"
						placeholder="Start Time"
						:readonly="true"
						:disabled="true"
					/>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_2"
						placeholder="End Time"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_wed" class="col-sm-3 mb-0"> Wed </label>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_3"
						placeholder="Start Time"
						:readonly="true"
						:disabled="true"
					/>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_3"
						placeholder="End Time"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_thu" class="col-sm-3 mb-0"> Thu </label>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_4"
						placeholder="Start Time"
						:readonly="true"
						:disabled="true"
					/>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_4"
						placeholder="End Time"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_fri" class="col-sm-3 mb-0"> Fri </label>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_5"
						placeholder="Start Time"
						:readonly="true"
						:disabled="true"
					/>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_5"
						placeholder="End Time"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sat" class="col-sm-3 mb-0"> Sat </label>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_6"
						placeholder="Start Time"
						:readonly="true"
						:disabled="true"
					/>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_6"
						placeholder="End Time"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sun" class="col-sm-3 mb-0"> Sat </label>
					<app-input
						id="inputs_sun"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_7"
						placeholder="Start Time"
						:readonly="true"
						:disabled="true"
					/>
					<app-input
						id="inputs_sun"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_7"
						placeholder="End Time"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_date_start" class="col-sm-3 mb-0">
						Start Date
					</label>
					<app-input
						id="inputs_date_start"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_start"
						placeholder="Start Date"
						:readonly="true"
						:disabled="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_date_clc_start" class="col-sm-3 mb-0">
						CLC Date Start
					</label>
					<app-input
						id="inputs_date_clc_start"
						class="col-sm-9"
						type="text"
						v-model="inputs.date_clc_start"
						placeholder="CLC Date Start"
						:readonly="true"
						:disabled="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "ScheduleRecommendationTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {
				course_name: "",
				course_schedule_name: "",
				product_id: "",
				time_start_1: "",
				time_end_1: "",
				time_start_2: "",
				time_end_2: "",
				time_start_3: "",
				time_end_3: "",
				time_start_4: "",
				time_end_4: "",
				time_start_5: "",
				time_end_5: "",
				time_start_6: "",
				time_end_6: "",
				time_start_7: "",
				time_end_7: "",
				date_start: "",
				date_clc_start: "",
			},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
			modalSize: "fullscreen",
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = "Detail Schedule Recommendation";
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			try {
				this.inputs.course_name = response.data?.course_id?.course_name;
				this.inputs.course_schedule_name =
					response.data?.course_schedule?.name;
				this.inputs.product_id = response.data?.product_id?.name;
				if (
					response.data?.course_schedule?.day_id?.day_name ===
					"Monday"
				) {
					this.inputs.time_start_1 = response.data?.course_schedule?.time_start
					this.inputs.time_end_1 = response.data?.course_schedule?.time_end
				} else if (
					response.data?.course_schedule?.day_id?.day_name ===
					"Tuesday"
				) {
					this.inputs.time_start_2 = response.data?.course_schedule?.time_start
					this.inputs.time_end_2 = response.data?.course_schedule?.time_end
				} else if (
					response.data?.course_schedule?.day_id?.day_name ===
					"Wednesday"
				) {
					this.inputs.time_start_3 = response.data?.course_schedule?.time_start
					this.inputs.time_end_3 = response.data?.course_schedule?.time_end
				} else if (
					response.data?.course_schedule?.day_id?.day_name ===
					"Thursday"
				) {
					this.inputs.time_start_4 = response.data?.course_schedule?.time_start
					this.inputs.time_end_4 = response.data?.course_schedule?.time_end
				} else if (
					response.data?.course_schedule?.day_id?.day_name ===
					"Friday"
				) {
					this.inputs.time_start_5 = response.data?.course_schedule?.time_start
					this.inputs.time_end_5 = response.data?.course_schedule?.time_end
				} else if (
					response.data?.course_schedule?.day_id?.day_name ===
					"Saturday"
				) {
					this.inputs.time_start_6 = response.data?.course_schedule?.time_start
					this.inputs.time_end_6 = response.data?.course_schedule?.time_end
				} else if (
					response.data?.course_schedule?.day_id?.day_name ===
					"Sunday"
				) {
					this.inputs.time_start_7 = response.data?.course_schedule?.time_start
					this.inputs.time_end_7 = response.data?.course_schedule?.time_end
				}
				this.inputs.date_start = response.data?.date_start;
				this.inputs.date_clc_start = response.data?.date_clc_start;
			} catch (error) {
				console.log(error);
			}

			this.preloader = false;
		},
	},
};
</script>
